import { Container } from '@/components/ui/container';
import { motion } from 'framer-motion';
import { Rocket, ArrowRight, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Link from 'next/link';

export default function LandingHero(): JSX.Element {
	return (
		<Container className="relative z-10">
			<div className="text-center max-w-3xl mx-auto px-4 relative">
				{/* Background Logo */}
				<div
					className="absolute inset-0 pointer-events-none -z-10 opacity-[0.03] dark:opacity-[0.08]"
					style={{
						backgroundImage: 'url(/images/logo/SVG/Icon/JCW_Logo_Updated_2026-09.svg)',
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center',
						backgroundSize: '1000px',
						transform: 'translateY(-80px)',
					}}
				/>
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
				>
					<h1 className="text-4xl sm:text-5xl md:text-7xl font-bold mb-6 sm:mb-8 cosmic-text font-space-grotesk">
						Your Fractional CTO for
						<span className="block text-orange-500 mt-2">Growing Businesses</span>
					</h1>
					<p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto">
						Strategic tech leadership, on demand — without the full-time hire.
					</p>
					<p className="text-lg sm:text-xl text-muted-foreground mb-8 sm:mb-12 max-w-2xl mx-auto pt-4">
						Get an ongoing tech partner who evaluates your systems, sets the roadmap, and builds
						alongside your team — automations, dashboards, and internal tools — all for the cost of
						a fraction of a full-time hire.
					</p>
					<div className="flex items-center justify-center gap-2 text-muted-foreground/80 mb-8">
						<MapPin className="w-5 h-5 text-orange-500" />
						<p className="text-base">
							Serving growing businesses in Alhambra, Monterey Park, Pasadena, Altadena, San
							Gabriel, and San Marino
						</p>
					</div>
					<div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
						<Link
							href="https://app.hellobonsai.com/s/joviancloudworks/discovery-call"
							target="_blank"
							rel="noopener noreferrer"
							className="w-full sm:w-auto"
						>
							<Button
								size="lg"
								className="group w-full sm:w-auto sm:min-w-[15rem] h-12 rounded-xl text-base font-semibold bg-orange-500 hover:bg-orange-600 text-white shadow-lg shadow-orange-500/25 transition-all"
							>
								Book a strategy call
								<Rocket className="ml-2 h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
							</Button>
						</Link>
						<Link href="/tools/tech-audit-assessment" className="w-full sm:w-auto">
							<Button
								size="lg"
								variant="outline"
								className="group w-full sm:w-auto sm:min-w-[15rem] h-12 rounded-xl text-base font-semibold border-2 border-purple-500/50 bg-transparent text-purple-600 dark:text-purple-300 hover:bg-purple-500/10 hover:border-purple-500 transition-all"
							>
								Take the free assessment
								<ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
							</Button>
						</Link>
					</div>
				</motion.div>
			</div>
		</Container>
	);
}
